import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { LegalShell } from "./privacy";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
  head: () => ({
    meta: [
      { title: "Terms of Service — Business Dite Ads" },
      {
        name: "description",
        content:
          "Terms governing the use of Business Dite Ads — eligibility, billing, cancellation, GPS data, and limitation of liability.",
      },
      { property: "og:title", content: "Terms of Service — Business Dite Ads" },
      { property: "og:url", content: "https://busditeads.com/terms" },
      {
        property: "og:description",
        content: "Terms governing the use of Business Dite Ads.",
      },
    ],
    links: [{ rel: "canonical", href: "https://busditeads.com/terms" }],
  }),
});

function TermsPage() {
  const { t } = useTranslation();
  return (
    <LegalShell>
      <article className="prose prose-sm max-w-none dark:prose-invert sm:prose-base">
        <p className="text-xs text-muted-foreground">{t("legal.lastUpdated")}: 2026-04-22</p>
        <h1>{t("legal.terms.title")}</h1>
        <p>{t("legal.terms.intro")}</p>

        <h2>{t("legal.terms.s1Title")}</h2>
        <p>{t("legal.terms.s1Body")}</p>

        <h2>{t("legal.terms.s2Title")}</h2>
        <p>{t("legal.terms.s2Body")}</p>

        <h2>{t("legal.terms.s3Title")}</h2>
        <p>{t("legal.terms.s3Body")}</p>

        <h2>{t("legal.terms.s4Title")}</h2>
        <p>{t("legal.terms.s4Body")}</p>

        <h2>{t("legal.terms.s5Title")}</h2>
        <p>{t("legal.terms.s5Body")}</p>

        <h2>{t("legal.terms.s6Title")}</h2>
        <p>{t("legal.terms.s6Body")}</p>

        <h2>{t("legal.terms.s7Title")}</h2>
        <p>{t("legal.terms.s7Body")}</p>

        <h2>{t("legal.terms.s8Title")}</h2>
        <p>{t("legal.terms.s8Body")}</p>

        <h2>{t("legal.terms.s9Title")}</h2>
        <p>
          {t("legal.terms.s9Body")}{" "}
          <a href="mailto:contact@diteads.com" className="text-primary hover:underline">
            contact@diteads.com
          </a>
          .
        </p>
      </article>
    </LegalShell>
  );
}
